import { gql } from "@apollo/client";

export const ALL_CLIENT_REF_ADDRESS_BY_CLIENT_ID = gql`
  query allClientRefAddressByClientId($params: ClientIdParams!) {
    results: allClientRefAddressByClientId(params: $params) {
      error
      code
      message
      data {
        _id
        firstname
        lastname
        default
        phone_number
        email
        address {
          country
          address
          place_id
        }
      }
    }
  }
`;
